<!-------------------------------------------Client certificaion save or update modal------------------------>
<span id="opencertificate" data-bs-target="#modalCertification" data-bs-toggle="modal"></span>
<div class="modal fade" id="modalCertification" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">
          <span *ngIf="ModelType =='new'"> Create Certification</span>
          <span *ngIf="ModelType =='edit'">Update Certification</span>
        </h5>
        <button type="button" class="btn-close" (click)="back();closeMOdel()" id="CERTcloseMOdelicon"></button>
      </div>
      <div class="alert alert-warning alert-dismissible fade show" *ngIf="saveorUpdatecertificationErr!=''"
        role="alert">
        <p>{{saveorUpdatecertificationErr}}</p>
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" id="CERTsaveorUpdatecertificationErr"
          (click)="saveorUpdatecertificationErr=''">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <!-- <div class="row alert ml-3 mr-3 alert-danger text-dark" *ngIf="saveorUpdatecertificationErr!=''">
        <strong>{{saveorUpdatecertificationErr}}</strong>
      </div> -->
      <div class="alert alert-warning alert-dismissible fade show" *ngIf="startofcaredate" role="alert">
        <p>Start of care has to be created before adding certification</p>
        <button type="button" class="close" data-bs-dismiss="alert" aria-label="Close" (click)="startofcaredate = false" id="CERTstartofcaredate">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <!-- <div class="row alert ml-3 mr-3 alert-danger text-dark" *ngIf="startofcaredate">
        <strong>Start of care has to be created before adding certification</strong>
      </div> -->
      <div class="modal-body">
        <div class="row">
          <div class="col-lg-6">
            <label>Start Of Care
              <sup class="super-script">&nbsp;*</sup></label>
          </div>
          <div class="col-lg-6">
            <ng-select [items]="CLientSOCList" id="CERTsocDropDown" class="w-100" [searchable]="true" [clearable]="true"
              bindLabel="socDateWithCompanyName" bindValue="startOfCareId" [ngModelOptions]="{standalone: true}"
              [(ngModel)]="ClientCertificationList.startOfCareId" 
              (ngModelChange)="socSelectedEvent(ClientCertificationList.startOfCareId)">
            </ng-select>

          </div>
        </div>
        <div class="row mt-1">
          <div class="col-lg-6">
            <label>Start Date
              <sup class="super-script">&nbsp;*</sup></label>
          </div>
          <div class="col-lg-6">
            <my-date-picker [options]="myDatePickerOptions" id="CERTCertificateSD" [selDate]="ClientCertificationList.startDate"
              placeholder="mm/dd/yyyy" (inputFieldChanged)="Certificationstartdatechange($event)"
              (dateChanged)="onDateChangedCertificationStart($event)">
            </my-date-picker>
          </div>
        </div>
        <div class="row mt-1">
          <div class="col-lg-6">
            <label>End Date</label>
          </div>
          <div class="col-lg-6">
            <my-date-picker [options]="myDatePickerOptions" id="CERTCertificateED" [selDate]="ClientCertificationList.endDate"
              placeholder="mm/dd/yyyy" (inputFieldChanged)="Certificationenddatechange($event)"
              (dateChanged)="onDateChangedCertificationEnd($event)">
            </my-date-picker>
          </div>
        </div>
        <div class="row mt-1">
          <div class="col-lg-6">
            <label>Company
              <sup class="super-script">&nbsp;*</sup></label>
          </div>
          <div class="col-lg-6">
            <ng-select [items]="companyList" class="w-100" id="CERTCertificateCompany" [searchable]="true" [clearable]="true" bindLabel="Value"
              bindValue="Key" [ngModelOptions]="{standalone: true}" [(ngModel)]="ClientCertificationList.companyId" [disabled]="true"
              >
            </ng-select>

          </div>
        </div>


        <div class="row mt-1">  
          <div class="col-lg-6">
            <label>ICD10(Primary)
              <sup class="super-script">&nbsp;*</sup></label>
          </div>
          <div class="col-lg-5">
            <ng-select [items]="ICD10List" [ngModelOptions]="{standalone: true}" id="CERTICD10Primary"
              [(ngModel)]="ClientCertificationList.icD10PrimaryId" class="w-100" [searchable]="true" [clearable]="true"
              bindLabel="Value" bindValue="Key"  [disabled]="true">
            </ng-select>
          </div>

          <div class="col-lg-1 paddingbtnl">
            <button class="btn btn-sm btn-primary mt-1 ml-1" data-bs-target="#ICD10" data-bs-toggle="modal" id="CERTenableICD10"
              (click)="enableICD10=true;">
              <i class="fa fa fa-eye" id="CERTCertificateEye"></i></button>
          </div>

          <!-- (click)="viewICD10Codes(icd10Codes)" -->
        </div>

        <div class="row mt-1">
          <div class="col-lg-6">
            <label>Physician NPI</label>
          </div>
          <div class="col-lg-5">
            <input type="text" placeholder="PhysicianNPI"  id="CERTCertificatePhysicianNPI"  [ngModelOptions]="{standalone: true}"
              [(ngModel)]="ClientCertificationList.npi" (keypress)="keyPress($event)" minlength=10 maxlength=10 class="form-control w-100"
              (keyup.enter)="searchNPI(ClientCertificationList.npi)" />
          </div>

          <div class="col-lg-1 paddingbtnl">
            <button class="btn btn-sm btn-primary ml-1 mt-1" [disabled]=" ClientCertificationList.npi==null || ClientCertificationList.npi==undefined
           " (click)="searchNPI(ClientCertificationList.npi);" >
              <i class="fa fa fa-search" id="CERTCertificatesearch"></i></button>
            <!-- <button class="btn btn-sm btn-primary ml-1 mt-1" data-bs-target="#PhysicanAdd" data-bs-toggle="modal"
              (click)="enablePhysican=true;">
              <i class="fa fa fa-eye"></i></button> -->
          </div>
          <!-- <div class="col-lg-1" *ngIf="ClientCertificationList.npi!=null && ClientCertificationList.npi!=undefined">

            <i class="fa fa-search" (click)="searchNPI(ClientCertificationList.npi)"></i>
          </div> -->
        </div>
        <div class="row mt-1">
          <div class="col-lg-6">
            <label>Physician Name</label>
          </div>
          <div class="col-lg-6">
            <input type="text" placeholder="PhysicianName"  [ngModelOptions]="{standalone: true}" class="form-control w-100"
              [(ngModel)]="ClientCertificationList.physician"   id="CERTCertificatePhysicianName"/>
          </div>
        </div>
        <div class="row mt-1">
          <div class="col-lg-6">
            <label>Physician Address</label>
          </div>
          <div class="col-lg-6">
            <input type="text" placeholder="PhysicianAddress"  [ngModelOptions]="{standalone: true}" class="form-control w-100"
              [(ngModel)]="ClientCertificationList.clinicAddress" id="CERTCertificatePhysicianAddress" />
          </div>
        </div>
        <div class="row mt-1">
          <div class="col-lg-6">
            <label>Physician Phone</label>
          </div>
          <div class="col-lg-6">
            <input type="text" placeholder="PhysicianPhone"  maxlength="14" minlength="14" class="form-control w-100"
              [(ngModel)]="ClientCertificationList.clinicPhone" (ngModelChange)="PhysicianPhoneFormat()"
              [ngModelOptions]="{standalone: true}" id="CERTCertificatePhysicianPhone" />
          </div>
        </div>
        <div class="row mt-1">
          <div class="col-lg-6">
            <label>Referring Provider NPI</label>
          </div>
          <div class="col-lg-6">
            <input type="text"   [ngModelOptions]="{standalone: true}" class="form-control w-100"
              [(ngModel)]="ClientCertificationList.referringProvider_NPI" />
          </div>
        </div>
        <div class="row mt-1">
          <div class="col-lg-6">
            <label>Refering Provider First Name</label>
          </div>
          <div class="col-lg-6">
            <input type="text"   [ngModelOptions]="{standalone: true}" class="form-control w-100"
              [(ngModel)]="ClientCertificationList.referringProvider_FirstName" />
          </div>
        </div>
        <div class="row mt-1">
          <div class="col-lg-6">
            <label>Refering Provider Last Name</label>
          </div>
          <div class="col-lg-6">
            <input type="text"   [ngModelOptions]="{standalone: true}" class="form-control w-100"
              [(ngModel)]="ClientCertificationList.referringProvider_LastName" />
          </div>
        </div>
        <div class="row mt-1">
          <div class="col-lg-6">
            <label>Refering Provider Middle Name</label>
          </div>
          <div class="col-lg-6">
            <input type="text"   [ngModelOptions]="{standalone: true}" class="form-control w-100"
              [(ngModel)]="ClientCertificationList.referringProvider_MiddleName" />
          </div>
        </div>
        <div class="row mt-1">
          <div class="col-lg-6">
            <label>Clinic</label>
          </div>
          <div class="col-lg-6">
            <textarea  [ngModelOptions]="{standalone: true}" class="form-control w-100"
              [(ngModel)]="ClientCertificationList.clinic" id="CERTCertificateClinic" ></textarea>
          </div>
        </div>

        <div class="row mt-1">
          <div class="col-lg-6">
            <label>837I Claim</label>
          </div>
          <div class="col-lg-2">
            <input type="checkbox"  [ngModelOptions]="{standalone: true}"
              [(ngModel)]="ClientCertificationList.is837I" (ngModelChange)="is837change()" id="CERTCertificate837IClaim">
          </div>
        </div>
        <span *ngIf="ClientCertificationList.is837I">
          <div class="row mt-1">
            <div class="col-lg-6">
              <label>First Digit Facility Code</label>
            </div>
            <div class="col-lg-6">
              <ng-select [items]="FirstDigitLst" class="w-100" [searchable]="true" [clearable]="false"
                bindLabel="lovName" bindValue="id" id="CERTCertificateFDFC" [ngModelOptions]="{standalone: true}"
                [(ngModel)]="ClientCertificationList.firstDigitFacilityLid">
              </ng-select>

            </div>
          </div>
          <div class="row mt-1">
            <div class="col-lg-6">
              <label>Second Digit Facility Code</label>
            </div>
            <div class="col-lg-6">
              <ng-select [items]="SecondDigitLst" class="w-100" [searchable]="true" [clearable]="false"
                bindLabel="lovName" bindValue="id" [ngModelOptions]="{standalone: true}"
                [(ngModel)]="ClientCertificationList.secondDigitFacilityLid" id="CERTCertificateSDFC">
              </ng-select>

            </div>
          </div>
          <div class="row mt-1">
            <div class="col-lg-6">
              <label>Frequency Code </label>
            </div>
            <div class="col-lg-6">
              <ng-select [items]="FrequencyLst" class="w-100" [searchable]="true" [clearable]="false"
                bindLabel="lovName" bindValue="id" [ngModelOptions]="{standalone: true}"
                [(ngModel)]="ClientCertificationList.frequncyCodeLid" id="CERTCertificateFC">
              </ng-select>

            </div>
          </div>
          <div class="row mt-1">
            <div class="col-lg-6">
              <label>Priority (Type) of Admission</label>
            </div>
            <div class="col-lg-6">
              <ng-select [items]="PrioritytypeLst" class="w-100" [searchable]="true" [clearable]="false"
                bindLabel="lovName" bindValue="id" [ngModelOptions]="{standalone: true}"
                [(ngModel)]="ClientCertificationList.priorityTypeOfAdmissionLid" id="CERTCertificatePTA">
              </ng-select>

            </div>
          </div>
          <div class="row mt-1">
            <div class="col-lg-6">
              <label>Point of Origin for Admission or Visit</label>
            </div>
            <div class="col-lg-6">
              <ng-select [items]="PointofOriginLst" class="w-100" [searchable]="true" [clearable]="false"
                bindLabel="lovName" bindValue="id" [ngModelOptions]="{standalone: true}"
                [(ngModel)]="ClientCertificationList.pointOfOriginForAdmissionOrVisitLid" id="CERTCertificatePOAV">
              </ng-select>

            </div>
          </div>
          <div class="row mt-1">
            <div class="col-lg-6">
              <label>Patient Discharge Status</label>
            </div>
            <div class="col-lg-6">
              <ng-select [items]="PatientDischargeLst" class="w-100" [searchable]="true" [clearable]="false"
                bindLabel="lovName" bindValue="id" [ngModelOptions]="{standalone: true}"
                [(ngModel)]="ClientCertificationList.patientDischargeStatusLid" id="CERTCertificatePDS">
              </ng-select>

            </div>
          </div>
        </span>


      </div>
      <div class="modal-footer">
        <button class="btn btn-primary btn-sm" id="CERTcheckCertificationValidation"
          [disabled]="certificationCreationinProgress || (ClientCertificationList.startOfCareId=='' || ClientCertificationList.startOfCareId==null || ClientCertificationList.startOfCareId==undefined || ClientCertificationList.startDate =='' || ClientCertificationList.startDate==null || ClientCertificationList.startDate==undefined || ClientCertificationList.companyId =='' || ClientCertificationList.companyId==null || ClientCertificationList.companyId==undefined || ClientCertificationList.icD10PrimaryId =='' || ClientCertificationList.icD10PrimaryId==null || ClientCertificationList.icD10PrimaryId==undefined)">
          <span *ngIf="ModelType =='new'" (click)="checkCertificationValidation(ClientCertificationList)" id="CERTCertificateSave"> Save &
            Close</span>
          <span *ngIf="ModelType =='edit'" (click)="checkCertificationValidation(ClientCertificationList)"  id="CERTCertificateUpdate">Update &
            Close</span> </button>
        <button type="button" class="btn btn-primary btn-sm" (click)="back();closeMOdel()" id="CERTCertificateClose">Close</button>
      </div>
    </div>
  </div>
</div>


<!-------------------------------------------Delete Certificate------------------------------------------------------------>
<span id="deletecertificatedata" data-bs-toggle="modal" data-bs-target="#deletecer"></span>
<div class="modal hide fade modalbackgrod" id="deletecer" tabindex="-1" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog  ">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">Delete Record</h5>

      </div>
      <div class="modal-body ">
        Do you want to delete this record ?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-primary" (click)="deleteCertificateConfirmation()" id="CERTdeleteCertificateConfirmation">Yes</button>

        <button type="button" class="btn btn-sm btn-primary" data-bs-dismiss="modal" (click)="back()" id="CERTback">No</button>
      </div>
    </div>
  </div>
</div>

<!-----------------------------------------------  ICD10       --------------------------------------------------------------->
<span id="ICD10eopen" data-bs-toggle="modal" data-bs-target="#ICD10"></span>
<div class="modal hide fade modalbackgrod" id="ICD10" tabindex="-1" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog  modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" (click)="Closedcdialog()" id="CERTClosedcdialog">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <div class="modal-body ml-1" >
        <app-icd10 *ngIf="enableICD10" (dataFromICD10)=ICD10data($event) [ICD10input]="ICD10value"></app-icd10>
      </div>
      <div class="modal-footer">

        <button type="button" class="btn btn-sm btn-primary" (click)="Closedcdialog()" id="CERTClosedcdialogbutton">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-----------------------------------------------  PhysicalAdress&PhoneNumber       --------------------------------------------------------------->
<span id="PhysicanDetailsopen" data-bs-toggle="modal" data-bs-target="#PhysicanAdd"></span>
<div class="modal hide fade modalbackgrod" id="PhysicanAdd" tabindex="-1" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog  modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-bs-dismiss="alert" aria-label="Close" (click)="closePhysicanModal()" id="CERTclosePhysicanModal">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body ml-1" style="height: 539px; overflow-y: auto;">
        <app-physician *ngIf="enablePhysican" (EventEmitFromPhysician)=EmitFromPhysicianData($event)></app-physician>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-primary" (click)="closePhysicanModal()" id="CERTclosePhysicanModalbutton">Cancel</button>
      </div>
    </div>
  </div>
</div>



